import { render, staticRenderFns } from "./addMail.vue?vue&type=template&id=997957ee"
import script from "./addMail.vue?vue&type=script&lang=js"
export * from "./addMail.vue?vue&type=script&lang=js"
import style0 from "./addMail.vue?vue&type=style&index=0&id=997957ee&prod&lang=scss"
import style1 from "./addMail.vue?vue&type=style&index=1&id=997957ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports